import { makeStyles } from '@mui/styles';
import React from 'react';
import HeroSection from './HeroSection';
import DashboardStats from './Dashboard';
import ReferralList from './TableView';
import referralIcon from '../../../assets/referral/referralIcon.svg';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: '70px',
  },
  tableContainer: {
    padding: '24px',
    maxWidth: '1380px',
    margin: 'auto',
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.divider}`,
    marginTop: '24px',

    [theme.breakpoints.down('md')]: {
      border: 'none !important',
    },
  },
}));

const Referral = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <>
      <div className={classes.container}>
        <HeroSection />
        <DashboardStats />
        <div style={{ maxWidth: '1380px', margin: '-70px auto 24px', padding: '0 24px' }}>
          <div style={{ background: '#164B36', color: '#fff', borderRadius: '16px', padding: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px', flexWrap: 'wrap', fontFamily: 'AvenirRegular, sans-serif' }}>
            <div>
              <div style={{ color: '#B9D4C8', fontSize: '13px', fontWeight: 700, letterSpacing: '1px' }}>SMART CRYPTO + TREASURY</div>
              <div style={{ margin: '6px 0', fontSize: '24px', fontWeight: 700, color: '#fff', fontFamily: 'AvenirHeavy, sans-serif' }}>Manage your referrals’ portfolios</div>
              <p style={{ margin: 0, color: '#D8E7E0' }}>Review allocations, monitor performance, and keep every referred client on track.</p>
            </div>
            <Button variant="contained" onClick={() => navigate('/referral/managed-portfolios')} style={{ background: '#FAAF02', color: '#20362d', fontWeight: 700, textTransform: 'none' }}>Open portfolio demo</Button>
          </div>
        </div>
        <div className={classes.tableContainer}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              gap: '00px',
              marginBottom: '10px',
            }}
          >
            <img src={referralIcon} alt="" style={{ height: '35px' }} />
            <h3 style={{ margin: '0' }}>Referral</h3>
          </div>

          <ReferralList />
        </div>
      </div>
    </>
  );
};

export default Referral;
